module.exports = __webpack_public_path__ + "static/media/mars3.6a21f55b.jpg";